// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container___xkZO","text":"Footer_text__Qzyjd","fade-in":"Footer_fade-in__hGsAf"};